var map = {
	"./arabic.json": 347,
	"./bulgarian.json": 348,
	"./czech.json": 349,
	"./denmark.json": 350,
	"./english.json": 351,
	"./finnish.json": 352,
	"./greek.json": 353,
	"./malay.json": 354,
	"./norwegian.json": 355,
	"./romanian.json": 356,
	"./slovakia.json": 357,
	"./swedish.json": 358,
	"./thai.json": 359
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;


//////////////////
// WEBPACK FOOTER
// ./src/locales/mobiscope ^\.\/.*\.json$
// module id = 1374
// module chunks = 0